<template>
    <div>
        <div v-if="AddressListFalse" >
            <img class="img_top" src="../../assets/images/icon_17.png" />
            <div class="nolistadd">
                <img src="@/assets/noaddlist.png" alt="" class="imgno">
                <div class="dizhi">还没有添加地址呢</div>
            </div>
        </div>
        <div v-else>
            <van-pull-refresh v-model="isLoading" @refresh="onRefresh" style="min-height:100vh;">
                <img class="img_top" src="../../assets/images/icon_17.png" />
                <ul >
                    <li
                        v-for="(item,index) in address"
                        :class="{move:candelete.id==item.id}"
                        @touchstart="touchStart(item,index)"
                        @touchend="touchEnd(item)"
                        :key="index"
                        >
                        <div class="box" @click="addindex(index)">
                            <div style="display:flex;justify-content: space-between;">
                                <div class="name van-ellipsis">{{item.name}}</div>
                                <div class="phone">
                                    <span class="phonephone">{{item.phone}}</span>
                                    <div class="black">
                                        <span v-if="item.type==0">家</span>
                                        <span v-if="item.type==1">公司</span>
                                        <span v-if="item.type==2">公司</span>
                                    </div>
                                </div>
                                <div class="bian_ji" @click="bian_ji(item.id)"><img src="@/assets/bj.png" alt="" class="bian_jiImg"></div>
                            </div>
                            <div style="display:flex;justify-content: flex-start;" class="left_imgFu">
                                <div class="left_img" v-if="item.defaultStatus == 1">默认 </div>
                                <div :class="item.defaultStatus==1?'details van-ellipsis':'detail van-ellipsis'">{{addrSplit(item.addrNameFull)}}{{item.detailAddress}}</div>
                            </div>
                        </div>
                        <div class="del" @click="deleteItem(item.id,index)">删除</div>
                    </li>
                </ul>
            </van-pull-refresh>
        </div>
        <div class="absolute">
            <van-button icon="plus" plain block @click="go">新建地址</van-button>
        </div>
    </div>
</template>
<script>
import { address, memberAddressDelete } from '@/request/api.js'
import { PullRefresh, tag, button } from 'vant'
export default {
  components: {
    [PullRefresh.name]: PullRefresh,
    [button.name]: button,
    [tag.name]: tag
  },
  data() {
    return {
      address: [],
      AddressListFalse: false,
      isLoading: false,
      index: 1,
      clientNum: {}, // 记录开始滑动（x1）,结束滑动（x2）的鼠标指针的位置
      candelete: {} // 滑动的item
    }
  },
  methods: {
    // 删除方法
    deleteItem(id, index) {
      // splice方法是删除数组某条数据，或者向某个位置添加数据
      const params = {
        id: id
      }
      memberAddressDelete(id, params).then(res => {
        if (res.code === 200) {
          this.address.splice(index, 1)
          // this.$router.go(0)
        }
      })
    //   cartItemdelete({ ids: id }).then(res => {
    //     if (res.code === 200) {
    //       this.list.splice(index, 1)
    //     }
    //     console.log(res)
    //   }).catch(res => {
    //     console.log(res)
    //   })
    },
    addindex(i) {
      if (event.target.className !== 'bian_jiImg') {
        this.$router.go(-1)
        sessionStorage.setItem('addindex', i)
      }
    },
    addrSplit (name) {
      return name.replace(/-/g, '')
    },
    // 收货地址
    loadAddress () {
      address().then(res => {
        console.log(res)
        if (res.code === 200) {
          if (res.data.length !== 0) {
            this.address = res.data
          } else {
            console.log(111111)
            this.AddressListFalse = true
          }
        }
      }).catch(res => {
        console.log(res)
      })
    },
    onRefresh() {
      console.log('下拉刷新')
      address().then(res => {
        console.log(res)
        if (res.code === 200) {
          if (res.data.length !== 0) {
            setTimeout(() => {
              this.isLoading = false
              this.address = res.data
            }, 1000)
          } else {
            this.AddressListFalse = true
          }
        }
      }).catch(res => {
        console.log(res)
      })
    },
    touchStart(item, index) {
      console.log(index)
      this.index = index
      const touchs = event.changedTouches[0]
      // 记录开始滑动的鼠标位置
      this.clientNum.x1 = touchs.pageX
    },
    touchEnd(item) {
      const touchs = event.changedTouches[0]
      // 记录结束滑动的鼠标位置
      this.clientNum.x2 = touchs.pageX
      this.candelete = {}
      // 判断滑动距离大于50，判定为滑动成功，否则失败
      if (
        this.clientNum.x2 < this.clientNum.x1 &&
      Math.abs(this.clientNum.x1) - Math.abs(this.clientNum.x2) > 50
      ) {
        event.preventDefault()
        this.candelete = item
      } else if (
        this.clientNum.x2 > this.clientNum.x1 &&
      Math.abs(this.clientNum.x2) - Math.abs(this.clientNum.x1) > 10
      ) {
        event.preventDefault()
        this.candelete = {}
      }
    },
    // 编辑
    bian_ji(i) {
      console.log(event)
      this.$router.push({ path: '/addressList', query: { DataDisplay: i } })
    //   DataDisplay
    },
    // 新建
    go() {
      this.$router.push('/addressList')
    }
  },
  created() {
    this.loadAddress()
  }
}
</script>
<style lang="less" scoped>
.nolistadd{
    width: 245px;
    margin: 30vh auto;
    .dizhi{
        color: #999999;
        font-size: 24px;
        width: 100%;
        text-align: center;
        margin-top: 40px;
    }
    .imgno{
        width: 245px;
        height: 223px;
    }
}
.ress_div{
    width:750px;
    height:162px;
    background:rgba(255,255,255,1);
}
.img_top{
    height: 10px;
    width: 100%;
}
li{
  height:140px;
  background:rgba(255,255,255,1);
  position: relative;
  transform: translateX(0);
  transition: all .3s; /*滑动效果更生动*/
  display: flex;
  justify-content: flex-start;
  border-bottom: 1px solid #000;
  padding-bottom: 10px;
}
ul{
  overflow-x: hidden; /*隐藏ul x轴的滚动条*/
}
li.move {
  transform: translateX(-160px); /*滑动后x轴位移-160px,使其可见*/
}
.del {
  position: absolute;
  top: 0;
  right: -1px;
  z-index: 3;
  width: 160px;
  height: 100%;
  border-radius: 4px;
  text-align: center;
  color: #fff;
  background-color: #B4272D;
  transform: translateX(160px); /*默认x轴位移100px，使其隐藏*/
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 28px;
}
.absolute {
    width: 100%;
    position: fixed;
    bottom: 0;
    height:98px;
    background:rgba(255,255,255,1);
    display: flex;
    justify-content: space-between;
    align-items: baseline ;
}
.box{
  width: 94%;
  background: white;
  margin: 0 auto;
  overflow: hidden;
  padding-top: 20px;
    .black{
        width:69px;
        height:32px;
        background:rgba(43,156,211,1);
        border-radius:4px;
        float: right;
        display: inline-flex;
        justify-content: center;
        align-items: center;
        color: white;
        margin-left: 20px;
    }
    .phone{
        margin-left: -150px;
    }
    .phonephone{
        font-size: 28px;
    }
    .name{
        color: #333333;
        font-size: 28px;
        width: 110px;
    }
    .details{
        color: #999999;
        font-size: 26px;
        padding-left: 20px;
    }
    .detail{
        color: #999999;
        font-size: 26px;
    }
    .left_img {
        width: 66px;
        height: 32px;
        padding: 0;
        display: inline-flex;
        align-items: center;
        justify-content: center;
        border:0.5px solid rgba(180,39,45,1);/*no*/
        border-radius:4px;
        color: rgba(180,39,45,1);
    }
    .left_imgFu{
        padding-top: 25px;

    }
    .bian_ji{
        width: 30px;
        height: 29px;
        img{
            width: 100%;
            height: 100%;
        }
    }
}
/deep/ .van-button--default{
    border: 0.5px solid rgba(180,39,45,1);/*no*/
    width:690px;
    height:70px;
    border-radius:4px;
    margin: 0 auto;
    color: rgba(180,39,45,1);
}
</style>
